module.exports = __webpack_public_path__ + "assets/images/icons/single.svg?v=8d0ac297";